// src/features/profile/api/profile/read.js

import axiosInstance from '@/lib/axios';

export async function readAdmin() {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {
    // If axiosInstance already sets Authorization via interceptor, you can skip headers here
    const response = await axiosInstance.get('/users/me', {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });

    return response.data; // already parsed JSON
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }
    throw error;
  }
}




export async function patchAdmin(formData) {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {
    const response = await axiosInstance.patch('/users/me', formData, {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }

    const errorMessage = error.response?.data || error.message;
    throw new Error('Failed to update profile: ' + JSON.stringify(errorMessage));
  }
}



export async function deleteAdmin() {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {
    const response = await axiosInstance.delete('/users/me', {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });

    return response.status === 200;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }
    throw new Error('Failed to delete account: ' + (error.response?.data || error.message));
  }
}


export async function patchPassword({ oldPassword, newPassword, confirmPassword }) {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {
    const response = await axiosInstance.patch(
      '/users/me/password',
      {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_new_password: confirmPassword,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${tokenType} ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }

    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Password change failed: ${message}`);
  }
}


export async function fetchSecurityQuestions() {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {
    const response = await axiosInstance.get('/admin/security_questions', {
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    });

    // Return empty array if no questions are found
    if (!response.data || response.data.length === 0 || response.data.detail === 'No security questions found') {
      return [];
    }

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }

    const errData = error.response?.data;
    if (errData?.detail === 'No security questions found') {
      return [];
    }

    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Failed to fetch security questions: ${message}`);
  }
}


export async function fetchUsrSecurityQuestions() {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {
    const response = await axiosInstance.get('/users/users_security_questions', {
      headers: { Authorization: `${tokenType} ${token}` },
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      // User has no security questions yet
      return [];
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }

    console.error('Failed to fetch user security questions:', error);
    throw new Error('Failed to fetch user security questions.');
  }
}

export async function createUsrSecurityQuestions(data) {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');

  if (!token || !tokenType) {
    throw new Error('Unauthorized. Please log in.');
  }

  try {

    const response = await axiosInstance.post(
      '/users/users_security_questions',
      data,
      {
        headers: {
          Authorization: `${tokenType} ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenType');
      throw new Error('Unauthorized. Authentication Expired');
    }

    const errData = error.response?.data;
    const message = errData?.detail || JSON.stringify(errData) || error.message;
    throw new Error(`Failed to save security question: ${message}`);
  }
}

export async function patchUsrSecurityQuestions(data) {


  const response = await axiosInstance.patch(
    '/users/users_security_questions',
    data

  );

  return response.data;

}